import { useTranslationsWithMarkup } from '@/shared/hooks/useTranslationsWithMarkup';
import translations from '@root/messages/en.json';

export type Translations = typeof translations;

export type TranslationProps<T extends keyof Translations> = {
  context: T;
  token: keyof Translations[T];
  withMarkup?: boolean;
};

const Translation = <T extends keyof Translations>({
  context,
  token,
  withMarkup = false,
}: TranslationProps<T>) => {
  const { translate, translateWithMarkup } = useTranslationsWithMarkup({ context });
  if (withMarkup) {
    return translateWithMarkup(token as any);
  }
  return translate(token as any) as string;
};

export default Translation;
